import Vue from 'vue'
export default Vue.extend({
  data () {
    return {
      termsToggle: false,
      allCheck: false,
      agreeList: []
    }
  },
  methods: {
    selectCheckAll () {
      this.allCheck = !this.allCheck
      this.agreeList.forEach(term => {
        term.isApprove = this.allCheck
      })
    },
    setAllCheck () {
      // 약관 모두 동의 일때 allCheck 체크
      this.allCheck = this.agreeList.every(term => term.isApprove)
    },
    termsToggleChange () { // 약관 팝업
      this.termsToggle = !this.termsToggle
    },
    termsDetailOpenHardCode (term) {
      term.isApprove = true // 약관동의 체크
      this.setAllCheck() // 전체 약관 동의하기
      /**
       * TODO : 약관 새창 열기 기능 사용 시 주석 해제
       */
      this.openTermWindow(term)
      /**
       * TODO : 약관 새창 열기 기능 사용 시 주석 처리
       */
      // this.$nextTick(async () => {
      //   const termModal = this.$refs.terms
      //   termModal.setTerm(term)
      //   await termModal.rawPdfContent()
      //   const container = termModal.$el.querySelector('.pop-terms-body')
      //   if (container) container.scrollTop = 0
      // })
      // this.termsToggle = !this.termsToggle
    }
  },
  computed: {
    termsFlag () { // 약관을 눌렀을때 position top 조정
      return this.termsToggle ? 'show' : ''
    }
  }

})
